module.exports = __webpack_public_path__ + "static/media/gold.15ca3dbb.png";